module.exports = __webpack_public_path__ + "static/media/happy-apple.715953af.png";